export const checkerboardBackground =
  "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill-opacity='0.05'%3e%3cpath d='M8 0h8v8H8zM0 8h8v8H0z'/%3e%3c/svg%3e\")";
